// https://fontawesome.com/icons
// import '@fortawesome/fontawesome-free/js/all';
// a comment can go here

import 'leaflet/dist/leaflet'; //necessary
import 'leaflet-defaulticon-compatibility';
import './leaflet-timeline-slider';

import hosts from './dataHosts';
import greatPlayers from './dataGreatPlayers';
//import rankings from './dataRankings';
import * as manageLayers from './manageLayers';
import * as manageLayerSetUp from './manageLayerSetUp';
import * as manageLayerText from './manageLayerText';
import confederations from './dataConfederations';
import dataPolygonsFirst from './dataPolygonsFirst';
import fifaEntities from './dataFIFAEntities';
//import fans from './dataFans';

//import clubs from './dataClubs';
import groups from './dataGroups';
import tournys from './dataTournys';
import stations from './dataStations.json';
import * as manageData from './manageData';
import * as htmlBuilder from './htmlBuilder';
import * as firebaseHelpers from './firebase/helpers';
import '../scss/styles.scss';
import settings from './dataSettings';
window.settings = settings;

function getActiveURLSafe() {
    try {
        return settings.globals && settings.globals.activeURL ? settings.globals.activeURL : null;
    } catch (e) {
        return null;
    }
}

function escapeHtml(text) {
    if (text == null) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

/** Shared closing paragraph for contact/activation emails. Single source of truth for both dialog and watermark. */
const CONTACT_EMAIL_CLOSING = '\n\n(Add your name, contact info, and any specific questions you have here. We look forward to hearing from you.)';

/**
 * Build full contact email body from first sentence and optional station ID.
 * Used by both the activation dialog and the watermark "Contact Us" link.
 * @param {string} firstSentence - Opening paragraph (e.g. "Dear OneWorld-Futbol,... Please contact us by email or phone.")
 * @param {string|null} [stationID] - Station ID to append when available (e.g. for scenario A).
 * @returns {string} Full email body.
 */
function buildContactEmailBody(firstSentence, stationID) {
    const closing = CONTACT_EMAIL_CLOSING + (stationID ? `\n\n${stationID}` : '');
    return firstSentence + closing;
}

function triggerActivationModal(featureName) {
    const modal = document.getElementById('activation-modal');
    if (!modal) return;

    // Remember current map layer so "Return to Evaluation" can restore after a blocked navigation.
    if (typeof settings.globals.activeLayerIndex === 'number') {
        settings.globals._layerBeforeActivationModal = settings.globals.activeLayerIndex;
    } else {
        settings.globals._layerBeforeActivationModal = null;
    }

    // 1. Update text based on the trigger and URL info
    const activeURL = getActiveURLSafe();
    const stationID = (activeURL && activeURL.station) ? activeURL.station : '';
    const marketName = (activeURL && activeURL.market) ? activeURL.market : '';
    const hasURLInfo = !!stationID;

    const headlineEl = document.getElementById('modal-headline');
    if (headlineEl) {
        headlineEl.innerHTML = hasURLInfo
            ? 'Professional Tier Required:<br><span class="modal-headline-subline">Exclusive broadcast rights available.</span>'
            : 'Professional Tier Required:<br><span class="modal-headline-subline">Exclusive broadcast rights in your market<br>may still be available.</span>';
    }

    // 2. Update body copy based on stationID and market
    const modalBody = document.getElementById('modal-body');
    const stationSpan = document.getElementById('station-name-text');
    const modalSubtext = document.querySelector('.modal-subtext');

    if (modalBody) {
        // Clear any existing content
        while (modalBody.firstChild) {
            modalBody.removeChild(modalBody.firstChild);
        }

        if (hasURLInfo) {
            // Station known — show market if available, otherwise just station
            if (marketName) {
                modalBody.innerHTML =
                    `Secure market exclusivity for <strong>${escapeHtml(marketName)}</strong>.` +
                    `<div class="modal-body-unlock">Unlock the full 2026 data suite and 4K assets for <strong>${escapeHtml(stationID)}</strong>.</div>`;
            } else {
                modalBody.innerHTML = `<div class="modal-body-unlock">Unlock the full 2026 data suite and 4K assets for <strong>${escapeHtml(stationID)}</strong>.</div>`;
            }
        } else {
            modalBody.appendChild(document.createTextNode(
                'Secure exclusivity for your territory. Unlock the full 2026 data suite and 4K assets for your station.'
            ));
        }
    }

    if (modalSubtext) {
        modalSubtext.style.display = 'none';
    }

    // Update the second-line copy in the dialog ("for X" vs "for your station")
    if (stationSpan) {
        if (stationID) {
            stationSpan.textContent = stationID;
        } else {
            stationSpan.textContent = 'your station';
        }
    }

    // 3. Build the personalized email link
    let subject = `Activation Request: ${featureName}`;
    const subjectParts = [];
    if (stationID) subjectParts.push(stationID);
    if (marketName) subjectParts.push(marketName);
    if (subjectParts.length) {
        subject += ' - ' + subjectParts.join(' ');
    }

    const body = stationID
        ? buildContactEmailBody(
            `Dear OneWorld-Futbol,\n\nWe are interested in unlocking the premium layers for the 2026 World Cup for ${stationID}. Please contact us by email or phone.`,
            stationID
        )
        : buildContactEmailBody(
            `Dear OneWorld-Futbol,\n\nWe are interested in unlocking the premium layers for the 2026 World Cup for our station. Please contact us by email or phone.`,
            null
        );
    const mailtoLink = `mailto:info@OneWorld-Futbol.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    const activationLink = document.getElementById('activation-link');
    if (activationLink) {
        activationLink.setAttribute('href', mailtoLink);
        activationLink.textContent = hasURLInfo ? `Request ${stationID} Activation` : 'Request Station Activation';
    }

    // 4. Show the modal
    modal.style.display = 'flex';
}

function closeModal() {
    const modal = document.getElementById('activation-modal');
    if (modal) modal.style.display = 'none';

    const prev = settings.globals._layerBeforeActivationModal;
    if (prev != null && typeof prev === 'number') {
        if (
            typeof settings.globals.activeLayerIndex === 'number' &&
            settings.globals.activeLayerIndex !== prev
        ) {
            htmlBuilder.switchModes(prev);
        }
        htmlBuilder.highlightMenuForLayer(prev);
    }
    settings.globals._layerBeforeActivationModal = null;
}

window.triggerActivationModal = triggerActivationModal;
window.closeModal = closeModal;


function buildBroadcastContactMailto(station, market, contactSubjectOverride, contactFirstSentenceOverride) {
    const contactSubject = contactSubjectOverride || 'Broadcast Package';
    const contactFirstSentence =
        contactFirstSentenceOverride ||
        (station
            ? `Dear OneWorld-Futbol,\n\nWe are interested in your 2026 World Cup Broadcast package for ${station}. Please contact us by email or phone.`
            : `Dear OneWorld-Futbol,\n\nWe are interested in your 2026 World Cup Broadcast package for our station. Please contact us by email or phone.`);
    const contactBody = buildContactEmailBody(contactFirstSentence, station || null);
    return `mailto:info@OneWorld-Futbol.com?subject=${encodeURIComponent(contactSubject)}&body=${encodeURIComponent(contactBody)}`;
}

window.buildBroadcastContactMailto = buildBroadcastContactMailto;

/**
 * MWC2026 Results / Groups / Talent Flow:
 * - No station query (?ID=...): block.
 * - ID not in dataStations.json: block.
 * - Known station in dataStations.json: block until Firebase sign-in, then allow.
 */
function shouldBlockMWC2026Menus() {
    if (!settings.globals.currentTourny || settings.globals.currentTourny.tournyID !== 'MWC2026') {
        return false;
    }
    const u = settings.globals.activeURL;
    if (!u) {
        return true;
    }
    if (!u.queryStationSegment) {
        return true;
    }
    if (!u.stationInDataStationsFile) {
        return true;
    }
    if (settings.globals.firebase && settings.globals.firebase.currentUserID) {
        return false;
    }
    return true;
}

/**
 * Station id from the query string: https://oneworld-futbol.com/?ID=KPTV
 * With no ID param, the site uses default OneWorld-Futbol branding.
 * (Hash is not used — avoids Leaflet popup close links changing the URL to #close.)
 */
function parseStationIdFromQuery() {
    try {
        const params = new URLSearchParams(window.location.search || '');
        const raw = params.get('ID');
        if (raw == null || raw === '') return null;
        const trimmed = String(raw).trim();
        if (!trimmed) return null;
        // Drop last two characters from the encoded ID segment (e.g. URL suffix).
        const withoutLastTwo = trimmed.slice(0, -2);
        return withoutLastTwo || null;
    } catch (e) {
        return null;
    }
}

/** Match switchModes watermark rules when the URL query changes after the map exists. */
function syncWatermarkVisibilityWithCurrentLayer() {
    const watermarkEl = document.getElementById('station-watermark');
    if (!watermarkEl || !settings.globals.map) return;
    const signedIn = !!(settings.globals.firebase && settings.globals.firebase.currentUserID);
    const activeURL = settings.globals.activeURL || {};
    const authorizedStationLogin =
        !!activeURL.queryStationSegment &&
        !!activeURL.stationInDataStationsFile &&
        signedIn;
    const idx = settings.globals.activeLayerIndex;
    if (idx === settings.layerIndices.helpLayerIndex || authorizedStationLogin) {
        watermarkEl.style.display = 'none';
    } else {
        watermarkEl.style.display = 'block';
    }
}

function initializeURLGlobals() {
    try {
        const stationID = parseStationIdFromQuery();
        console.log('[URL Debug] search:', window.location.search, '| stationID:', stationID);

        if (!settings.globals.activeURL) {
            settings.globals.activeURL = {
                station: null,
                market: null,
                inTier: null,
                requiresFirebaseLogin: false,
                queryStationSegment: null,
                stationInDataStationsFile: false,
            };
        }

        let station = null;
        let market = null;
        let tier = null;
        let requiresFirebaseLogin = false;
        let queryStationSegment = null;
        let stationInDataStationsFile = false;

        if (stationID) {
            queryStationSegment = stationID;
            const stationData = stations.find(
                s => s.stationID.toLowerCase() === stationID.toLowerCase()
            );
            if (stationData) {
                station = stationData.stationID;
                market = stationData.market;
                tier = stationData.tier;
                requiresFirebaseLogin = true;
                stationInDataStationsFile = true;
                console.log('[URL Debug] Found station data:', stationData);
            } else {
                station = stationID;
                market = null;
                tier = null;
                requiresFirebaseLogin = false;
                stationInDataStationsFile = false;
                console.log('[URL Debug] Station not found in database, using URL value:', stationID);
            }
        }

        settings.globals.activeURL.station = station;
        settings.globals.activeURL.market = market;
        settings.globals.activeURL.inTier = tier;
        settings.globals.activeURL.requiresFirebaseLogin = requiresFirebaseLogin;
        settings.globals.activeURL.queryStationSegment = queryStationSegment;
        settings.globals.activeURL.stationInDataStationsFile = stationInDataStationsFile;

        // Show watermark: station version when present, otherwise generic (OneWorld-Futbol).
        const watermarkEl = document.getElementById('station-watermark');
        if (watermarkEl) {
            // Label + clock line
            const countdownHtml =
                '<span class="watermark-line">KICKOFF IN: ' +
                '<span class="watermark-timer" id="station-watermark-bottom-countdown"></span>' +
                '</span>';
            const contactSubject = 'Broadcast Package';
            const contactFirstSentence = station
                ? `Dear OneWorld-Futbol,\n\nWe are interested in your 2026 World Cup Broadcast package for ${station}. Please contact us by email or phone.`
                : `Dear OneWorld-Futbol,\n\nWe are interested in your 2026 World Cup Broadcast package for our station. Please contact us by email or phone.`;
            const contactBody = buildContactEmailBody(contactFirstSentence, station || null);
            const contactMailto = buildBroadcastContactMailto(station, null, contactSubject, contactFirstSentence);
            const contactHtml = `<a href="${contactMailto}" class="licensing-link" target="_blank" rel="noopener noreferrer">INQUIRE ABOUT EXCLUSIVE BROADCAST RIGHTS</a>`;
            // Countdown line, then licensing CTA (former third line; status line removed)
            const html = countdownHtml + contactHtml;

            watermarkEl.innerHTML = html;
            watermarkEl.style.display = 'block';
        }

        if (settings.globals.map) {
            syncWatermarkVisibilityWithCurrentLayer();
        }
        initializeTopCountdown();
    } catch (e) {
        // Fail silently if URL parsing is not available for some reason
        // (e.g., non-browser environment).
    }
}

function setupActivationModalMenuGuards() {
    const header = document.getElementById('Header');
    if (!header || !settings.globals || !settings.globals.currentTourny) return;

    const currentTourny = settings.globals.currentTourny;
    const isMWC2026 = currentTourny && currentTourny.tournyID === 'MWC2026';

    // Only attach MWC2026-specific handlers for the 2026 tournament
    if (!isMWC2026) return;

    const lockedMenus = [
        { basename: 'Results', featureName: '2026 Results' },
        { basename: 'Groups', featureName: '2026 Groups' },
        { basename: 'Talent Flow', featureName: '2026 Talent Flow' },
    ];

    lockedMenus.forEach((config) => {
        const dropdownMain = header.querySelector(
            `.nav-item.dropdown .dropdown_main[data-basename="${config.basename}"]`
        );
        if (!dropdownMain) return;

        const navItem = dropdownMain.closest('.nav-item.dropdown');
        if (!navItem) return;

        const featureName = config.featureName;

        // Intercept clicks only while case (c) + not yet signed in; after login, normal navigation applies
        // Capture phase runs before inline onclick="switchModes(...)" on the same anchor, so the map
        // does not switch to the blocked layer. stopImmediatePropagation also blocks the header's
        // bubble listener that would mark the wrong menu item active.
        navItem.querySelectorAll('.dropdown-item').forEach((link) => {
            link.addEventListener(
                'click',
                (e) => {
                    if (!shouldBlockMWC2026Menus()) return;
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    triggerActivationModal(featureName);
                },
                true
            );
        });

        dropdownMain.addEventListener(
            'click',
            (e) => {
                if (!shouldBlockMWC2026Menus()) return;
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                triggerActivationModal(featureName);
            },
            true
        );
    });
}

function setUpMap() {
    settings.globals.map = new L.Map('map', {
        zoomDelta: settings.map.zoomDelta,
        zoomSnap: settings.map.zoomSnap,
        zoomControl: false,
        attributionControl: false,
    }).setView([0, 0], 1); //this view is just a placeholder

    settings.globals.map.on('popupopen', (e) => {
        if (e.popup.myOnOpenPopUpFunc) {
            // if there is a function that needs running
            e.popup.myOnOpenPopUpFunc(e.popup.entityID); //then run it
        }

        // Check if popup content actually overflows - only enable scrolling if needed
        // Use setTimeout to ensure DOM is fully rendered
        setTimeout(() => {
            const contentElement = e.popup._contentNode || e.popup._container?.querySelector('.leaflet-popup-content');
            if (contentElement) {
                const hasFlagContainer = contentElement.querySelector('.flag-container');
                if (hasFlagContainer) {
                    const scrollHeight = contentElement.scrollHeight;
                    const clientHeight = contentElement.clientHeight;

                    // Only enable scrolling if content actually overflows (with 2px tolerance for rounding)
                    if (scrollHeight <= clientHeight + 2) {
                        contentElement.style.overflowY = 'hidden';
                        contentElement.style.maxHeight = 'none'; // Remove max-height constraint when not needed
                    } else {
                        contentElement.style.overflowY = 'auto';
                    }
                }
            }
        }, 0);
    });

    settings.globals.map.setMaxZoom(settings.map.maxZoom);
}
/**
 * @param whichTourny
 */
function initializeNonChangingGlobals() {
    settings.polygons = dataPolygonsFirst; //these don't change based on tourny
    //settings.globals.clubs = clubs; //these don't change based on tourny
    settings.groups = groups; //these don't change based on tourny
    settings.fifaEntities = fifaEntities; //these don't change based on tourny
    //settings.fans = fans; //these don't change based on tourny
    settings.confederations = confederations; //the tally's do change and get re-intialized (see tally)
    settings.tournys = tournys.tournaments; //these don't change based on tourny
    settings.hosts = hosts; //these don't change based on tourny
    settings.greatPlayers = greatPlayers; //these don't change based on tourny
    manageLayerSetUp.setUpLayerParameters();
}

async function initializeTourny(whichTourny) {
    let theTourny = settings.tournys.find((k) => k.tournyID === whichTourny);
    if (theTourny) {
        await manageData.pullCorrectData(whichTourny); //this comes first because everything else depends on it

        htmlBuilder.dumpLayers();
        htmlBuilder.initializeMenuAndSideBar(); //some menu items are tourny dependent
        setupActivationModalMenuGuards();

        settings.globals.currentTeamID = settings.globals.currentTourny.startEntityID;
        settings.globals.currentFromEntityID = settings.globals.currentTourny.startEntityID;
        manageData.tallyResults();
        manageLayerText.getGroupStandingsText();

        manageData.tallyPlayersComingToFromConfederations(); //this should be not always be called because for certain tournaments this is irrelevant

        htmlBuilder.addHeaderActiveClass();
        htmlBuilder.addSideBarActiveClass();

        //some layers on tourny dependent, create all each time the tourny changes for simplicity
        manageLayers.createLayers();

        // event listeners:  these listeners get re-installed because the menu gets rebuilt for each tourny
        document.querySelector('.hamburger').addEventListener('click', function (e) {
            let state = document.querySelector('html').getAttribute('data-mobile_nav_open') === 'true';
            document.querySelector('html').setAttribute('data-mobile_nav_open', !state);
        });

        document.querySelector('.tourny_selectorMenu').addEventListener('click', function (e) {
            const tournyID = e.target.getAttribute('data-tournyID');
            initializeTourny(tournyID);
            //}, 300);
        });
        setTimeout(function () {
            // LOGIN REMOVAL: Always show Dashboard layer on startup (no automatic Getting Started layer).
            // Previous behavior (now disabled) opened the Getting Started (Help) layer on first login:
            // if (settings.globals.firebase.isFirstLogin) {
            //     htmlBuilder.switchModes(settings.layerIndices.helpLayerIndex);
            // } else {
            //     const startLayerElement = document.querySelector('[data-start_layer]');
            //     if (startLayerElement) {
            //         startLayerElement.click();
            //     }
            // }

            // New behavior: always use the configured start layer.
            const startLayerElement = document.querySelector('[data-start_layer]');
            if (startLayerElement) {
                startLayerElement.click();
            }
        }, 300);
    }
}

const map = document.getElementById('map');

/** Cleared when watermark HTML is rebuilt (e.g. hash change) so we do not leak intervals. */
let countdownIntervalId = null;

function initializeTopCountdown() {
    const bottomCountdownEl = document.getElementById('station-watermark-bottom-countdown');
    if (!bottomCountdownEl) return;

    if (countdownIntervalId !== null) {
        clearInterval(countdownIntervalId);
        countdownIntervalId = null;
    }

    const target = new Date('2026-06-11T19:00:00Z'); // June 11, 2026 15:00 in US Eastern (EDT, UTC-4)

    function updateCountdown() {
        const now = new Date();
        let diff = target.getTime() - now.getTime();
        if (diff < 0) diff = 0;

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / (24 * 60 * 60));
        const hours = Math.floor((totalSeconds - days * 24 * 60 * 60) / (60 * 60));
        const minutes = Math.floor((totalSeconds - days * 24 * 60 * 60 - hours * 60 * 60) / 60);
        const seconds = totalSeconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

        const pad = (value) => String(value).padStart(2, '0');
        const parts = [String(days), pad(hours), pad(minutes), pad(seconds)];
        // Use thin spaces (U+2009) around DAYS to visually tighten spacing
        const text = `${parts[0]}\u202FDAYS,${parts[1]}:${parts[2]}:${parts[3]}`;

        bottomCountdownEl.textContent = text;
    }

    updateCountdown();
    // Update continuously rather than once per minute
    countdownIntervalId = setInterval(updateCountdown, 1000);
}

/**
 * Firebase login before map/content when ?ID= matches a known station (dataStations.json).
 * Other visits use the direct init path in the map block below.
 */
function startAppWithFirebaseLoginGate(mapEl) {
    const header = document.querySelector('#Header');
    const leftBarContainer = document.querySelector('#LeftBarContainer');
    const watermarkEl = document.getElementById('station-watermark');

    document.querySelector('html').setAttribute('data-authenticated', 'false');

    if (mapEl) mapEl.style.display = 'none';
    if (header) header.style.display = 'none';
    if (watermarkEl) watermarkEl.style.display = 'none';

    window.addEventListener('userAuthenticated', async function (event) {
        if (event.detail && event.detail.needsInitialization && !settings.globals.map) {
            const firebaseUser = event.detail.firebaseUser;
            if (firebaseUser) {
                await firebaseHelpers.ensureUserDocAndSetFirstLoginFlag(firebaseUser);
            }
            setUpMap();
            initializeNonChangingGlobals();
            initializeTourny(settings.misc.startTourny);

            if (settings.globals.firebase.callBackLayerIndex !== null) {
                const callBackLayer = settings.globals.firebase.callBackLayerIndex;
                settings.globals.firebase.callBackLayerIndex = null;
                setTimeout(() => {
                    htmlBuilder.switchModes(callBackLayer);
                }, 100);
            }
        }
    });

    firebaseHelpers
        .initFirebase()
        .then(async (firebaseUser) => {
            if (firebaseUser) {
                await firebaseHelpers.ensureUserDocAndSetFirstLoginFlag(firebaseUser);

                document.querySelector('html').setAttribute('data-authenticated', 'true');

                if (mapEl) mapEl.style.display = '';
                if (header) header.style.display = '';

                const loginContainer = document.querySelector('#myFirebaseUI-Container');
                if (loginContainer) loginContainer.style.display = 'none';

                setUpMap();
                initializeNonChangingGlobals();
                initializeTourny(settings.misc.startTourny);

                if (settings.globals.firebase.callBackLayerIndex !== null) {
                    const callBackLayer = settings.globals.firebase.callBackLayerIndex;
                    settings.globals.firebase.callBackLayerIndex = null;
                    setTimeout(() => {
                        htmlBuilder.switchModes(callBackLayer);
                    }, 100);
                }
            } else {
                document.querySelector('html').setAttribute('data-authenticated', 'false');

                initializeNonChangingGlobals();

                if (leftBarContainer) {
                    leftBarContainer.style.display = 'block';
                    leftBarContainer.style.opacity = '1';
                    leftBarContainer.style.width = '100%';
                    leftBarContainer.style.position = 'relative';
                    leftBarContainer.style.zIndex = '1000';
                }

                htmlBuilder.buildSubscribe();
                if (watermarkEl) watermarkEl.style.display = 'none';

                setTimeout(() => {
                    const loginContainer = document.querySelector('#myFirebaseUI-Container');
                    if (loginContainer) {
                        loginContainer.style.display = 'block';
                        firebaseHelpers.handleLogInAndSubscribe();
                    } else {
                        console.error('Login container not found after buildSubscribe');
                    }
                }, 100);
            }
        })
        .catch((error) => {
            console.error('Error initializing Firebase:', error);
            if (watermarkEl) watermarkEl.style.display = 'none';
            const loginContainer = document.querySelector('#myFirebaseUI-Container');
            if (loginContainer) {
                loginContainer.style.display = 'block';
                firebaseHelpers.handleLogInAndSubscribe();
            }
        });
}

if (map) {
    initializeURLGlobals();

    window.addEventListener('popstate', () => {
        initializeURLGlobals();
        const titleEl = document.getElementById('siteTitleLineOne');
        if (titleEl && htmlBuilder.getSiteTitleBlockHtml) {
            titleEl.innerHTML = htmlBuilder.getSiteTitleBlockHtml();
        }
    });

    const needsFirebaseLogin =
        settings.globals.activeURL && settings.globals.activeURL.requiresFirebaseLogin;

    if (needsFirebaseLogin) {
        startAppWithFirebaseLoginGate(map);
    } else {
        setUpMap();
        initializeNonChangingGlobals();
        initializeTourny(settings.misc.startTourny);
    }
}
